import React from 'react';
import './AboutKadoona.css';
import KadounaLogo from '../../assets/images/activation1.svg';
import KadounaCardImage from '../../assets/images/activation2.png';

/**
 * معرفی کادونا
 * بازطراحی واکنش‌گرا بر اساس دو پوستر مرجع.
 * تمام متن‌ها HTML واقعی هستند و صفحه برای موبایل بهینه شده است.
 */
function AboutKadouna({ onBack }) {
    return (
        <section id="about-kadouna" className="kadouna-about" dir="rtl">
            <header className="kadouna-about-topbar">
                <button
                    type="button"
                    className="kadouna-back-btn"
                    onClick={onBack}
                    aria-label="بازگشت به خدمات کارت"
                >
                    <span aria-hidden="true">→</span>
                </button>

                <strong>معرفی کادونا</strong>

                <span className="kadouna-topbar-spacer" aria-hidden="true" />
            </header>

            <section className="kadouna-about-hero">
                <div className="kadouna-brand-mark">
                    <img
                        src={KadounaLogo}
                        alt="کادونا"
                        className="kadouna-brand-logo"
                    />
                </div>

                <div className="kadouna-hero-stage">
                    <div className="kadouna-glow-ring">
                        <img
                            src={KadounaCardImage}
                            alt="کارت هدیه کادونا"
                            className="kadouna-hero-card-image"
                        />
                    </div>
                </div>

                <h1>نسل جدید کارت‌های بانکی</h1>
                <p>
                    کارت هدیه‌ای متفاوت برای خرید، هدیه دادن و ساختن یک تجربه
                    ساده‌تر و جذاب‌تر از پرداخت.
                </p>

                <div className="kadouna-actions">
                    <article className="kadouna-action action-buy">
                        <span className="kadouna-action-icon">💳</span>
                        <strong>بخرید</strong>
                    </article>

                    <article className="kadouna-action action-charge">
                        <span className="kadouna-action-icon">📱</span>
                        <strong>شارژ کنید</strong>
                    </article>

                    <article className="kadouna-action action-gift">
                        <span className="kadouna-action-icon">🎁</span>
                        <strong>هدیه بدهید</strong>
                    </article>
                </div>
            </section>

            <div className="kadouna-about-body">
                <section className="kadouna-info-section">
                    <div className="kadouna-section-heading heading-red">
                        <span className="kadouna-heading-icon">🏪</span>
                        <div>
                            <small>کادونا</small>
                            <h2>را از کجا بخریم؟</h2>
                        </div>
                    </div>

                    <article className="kadouna-info-card border-red">
                        <p>
                            از سوپرمارکت‌ها و فروشگاه‌های زنجیره‌ای معتبر در سراسر
                            کشور، کادونا را به‌راحتی خریداری کنید.
                        </p>
                    </article>
                </section>

                <section className="kadouna-info-section">
                    <div className="kadouna-section-heading heading-green">
                        <span className="kadouna-heading-icon">📲</span>
                        <div>
                            <small>کادونا</small>
                            <h2>را چطور شارژ کنیم؟</h2>
                        </div>
                    </div>

                    <article className="kadouna-info-card border-green">
                        <div className="kadouna-method">
                            <span className="kadouna-method-number">۱</span>
                            <div>
                                <strong>روش اول</strong>
                                <p>
                                    کد QR پشت کارت را با گوشی اسکن کنید تا مستقیماً
                                    وارد صفحه شارژ شوید و مراحل را به‌سادگی تکمیل کنید.
                                </p>
                            </div>
                        </div>

                        <div className="kadouna-method">
                            <span className="kadouna-method-number">۲</span>
                            <div>
                                <strong>روش دوم</strong>
                                <p>
                                    به سایت کادونا مراجعه کرده و گزینه «شارژ و
                                    فعال‌سازی» را انتخاب کنید. فرم مربوطه را تکمیل
                                    کرده و وارد درگاه بانکی شوید.
                                </p>
                            </div>
                        </div>

                        <div className="kadouna-method">
                            <span className="kadouna-method-number">۳</span>
                            <div>
                                <strong>روش سوم</strong>
                                <p>
                                    اپلیکیشن تاپ را دانلود کنید، وارد بخش کارت هدیه
                                    شوید و گزینه شارژ و فعال‌سازی کارت هدیه کادونا را
                                    انتخاب کنید.
                                </p>
                            </div>
                        </div>
                    </article>
                </section>

                <section className="kadouna-info-section">
                    <div className="kadouna-section-heading heading-blue">
                        <span className="kadouna-heading-icon">★</span>
                        <div>
                            <small>قابلیت‌های</small>
                            <h2>کادونا</h2>
                        </div>
                    </div>

                    <article className="kadouna-info-card border-blue">
                        <div className="kadouna-feature-list">
                            <div className="kadouna-feature-item">
                                <span className="kadouna-feature-check">✓</span>
                                <div className="kadouna-feature-text">
                                    کارت‌ها خام هستند و در هر ساعتی از شبانه‌روز
                                    قابل شارژ می‌باشند.
                                </div>
                            </div>

                            <div className="kadouna-feature-item">
                                <span className="kadouna-feature-check">✓</span>
                                <div className="kadouna-feature-text">
                                    دسترسی آسان و فوری به کارت‌ها در سوپرمارکت‌ها و
                                    فروشگاه‌های زنجیره‌ای.
                                </div>
                            </div>

                            <div className="kadouna-feature-item">
                                <span className="kadouna-feature-check">✓</span>
                                <div className="kadouna-feature-text">
                                    امکان خرید از تمام کارت‌خوان‌های شبکه شتاب.
                                </div>
                            </div>

                            <div className="kadouna-feature-item">
                                <span className="kadouna-feature-check">✓</span>
                                <div className="kadouna-feature-text">
                                    امکان انجام خریدهای اینترنتی.
                                </div>
                            </div>
                        </div>
                    </article>
                </section>

                <section className="kadouna-about-cta">
                    <div>
                        <strong>یک هدیه متفاوت بسازید</strong>
                        <span>کادونا؛ ساده، سریع و همیشه در دسترس</span>
                    </div>
                    <span className="kadouna-cta-gift" aria-hidden="true">🎁</span>
                </section>
            </div>
        </section>
    );
}

export default AboutKadouna;
